import {
  EpisodEvent,
  init,
  sendEvent,
  set,
} from '@ingka-group/episod-client-js';

let __isInitialized__ = false;

export type EpisodConfig = {
  url: string;
  xClientId: string;
  cookieDomain: string;
};

export const initEpisod = async (episodConfig: EpisodConfig) => {
  const commons = {
    event_origin: 'checka',
    event_origin_team: 'checka',
  };

  const { url, xClientId, cookieDomain } = episodConfig;

  init({
    cookieDomain,
    url,
    xClientId,
    commons,
  });
  __isInitialized__ = true;
};

export const sendEpisodEvent = (event: EpisodEvent) => {
  if (__isInitialized__) sendEvent(event);
};

export const setEpisodContext = (context: EpisodEvent) => {
  if (__isInitialized__) set(context);
};
